import { Component, OnInit } from '@angular/core';
import { LoginService } from '../home/login.service';
import {
  FormBuilder,
  Validators,
  RadioControlValueAccessor,
} from '@angular/forms';
import { CheckoutService } from '../checkout/checkout.service';
//import {CartComponent } from '../cart/cart.component';
import { IRep } from '../home/rep';
import { ICartItems } from '../onlineorder/cartitems';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
//import { CartComponent } from '../cart/cart.component';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { Subscription } from 'rxjs';
import { ProductService } from '../products/products.service';
import { OrderService } from '../onlineorder/order.service';
import { ToastrService } from 'ngx-toastr';
import { IRepPublicData } from '../home/repPublicData';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  standalone: false,
  templateUrl: './completed.component.html',
})
export class CompletedComponent implements OnInit {
  public pageTitle: string = 'Order Completed';
  public orderId!: string;
  private sub!: Subscription;
  public caption: string;
  public transErrMsg: string;
  translatedText = '';

  constructor(
    private _loginService: LoginService,
    public fb: FormBuilder,
    public checkout: CheckoutService,
    public orderService: OrderService,
    public router: Router,
    public toaster: ToastrService,
    public app: AppComponent,
    private _route: ActivatedRoute,
    private _productService: ProductService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService
  ) {}

  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  logoutSuccess(message: string, caption: string): void {
    // translate the error message - not dynamic
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // translate the caption
    this.translate.get(caption).subscribe((res: string) => {
      this.caption = res;
      console.log(res);
    });
    this.spinner.hide();
    //show the toaster popup
    this.toaster.success(this.transErrMsg, this.caption, {
      timeOut: 5000,
    });
  }
  ngOnInit() {
    this.sub = this._route.params.subscribe((params) => {
      let id = +params['id'];
      this._productService
        .getRepInfo(id.toString())
        .subscribe((rep: IRepPublicData) => {
          //this.rep = rep;
          this.app.rep = rep;
        });
      localStorage.setItem('repId', id.toString());
    });

    this.orderId = localStorage.getItem('completedOrder') || '';
    setTimeout((router: Router) => {
      //this.app.myRepID = this.repId();
      this._loginService.logOut();
      this._loginService.token = '';
      this._loginService.refresh_token = '';
      this._loginService.custName = '';
      this.app.myCustName = '';
      this.orderService.clearCart(true);
      this.app.loggedIn = false;
      this._loginService.isAuthenticated = false;
      this.app.myProdCount = 0;
      this.logoutSuccess(
        'orderCompleted.toastPopup.success.logoutSuccess',
        'orderCompleted.toastPopup.title.success'
      );
      //this._loginService.
      this.router.navigateByUrl('shop/from/' + this.repId());
    }, 10000);
  }
}
